import { render, staticRenderFns } from "./on-service-system-messages.vue?vue&type=template&id=698ac6ac"
import script from "./on-service-system-messages.vue?vue&type=script&lang=js"
export * from "./on-service-system-messages.vue?vue&type=script&lang=js"
import style0 from "./on-service-system-messages.vue?vue&type=style&index=0&id=698ac6ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports